export class DateFormats{
    public static YEAR_MONTH_DAY = "YYYYMMDD";
    public static YEAR_MONTH_DAY_TIME = "YYYYMMDDTHHmm";
    public static GERMAN_DATE = "DD.MM.YYYY";
    public static GERMAN_DATE_S = "D.M.YYYY";
    public static ENGLISH_DATE = "MM/DD/YYYY";
    public static ENGLISH_DATE_S = "M/D/YYYY";
    public static ISO8601_LONG = "YYYY-MM-DD"
    public static HOUR_MINUTE = "HH:mm"
    public static LANGUAGE_OPTIONS: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
}

